import React from 'react'
import Card from '@loyal_images/landings/cashBack/card.png'
import Cash from '@loyal_images/landings/cashBack/cash.png'
import Circle from '@loyal_images/landings/cashBack/circle.png'

const CashbackInfo = () => {
  return (
    <div className='cashback-info'>
      <div className='container'>
        <h2>
          <span aria-hidden='true'> Saiba como ganhar até <strong>6% de cashback</strong> no shopping iupp com crédito na fatura.</span>
          <span className='hide-absolute'>Saiba como ganhar até 6% de cashback no shopping iupp com crédito na fatura.</span>
        </h2>
        <div className='list-cards'>
          <span className='hide-absolute'>Compre com seu cartão de crédito Itaucard ou Personnalité no shopping iupp.</span>
          <div className='card'>
            <img aria-hidden='true' src={Card} title='icon compre com seu cartão de crédito' />
            <p>
              Compre com seu cartão de crédito
              Itaucard ou Personnalité no
              shopping iupp e <strong>ganhe 3 pontos a cada real gasto.</strong>
            </p>
            <span className='hide-absolute'>Compre com seu cartão de crédito Itaucard ou Personnalité no shopping iupp.</span>
          </div>
          <div className='card'>
            <img aria-hidden='true' src={Circle} title='icon trocar seus pontos por crédito' />
            <p aria-hidden='true'>
              Com os pontos que ganhou
              na compra, você poderá escolher em
              <strong> trocar os seus pontos por crédito
                na fatura</strong> do seu cartão Itaú.
            </p>
            <span className='hide-absolute'>Com os pontos que ganhou na compra, você poderá escolher em trocar os seus pontos por crédito na fatura do seu cartão Itaú.</span>
          </div>
          <div className='card'>
            <img aria-hidden='true' src={Cash} title='icon pontos recebidos e trocados por crédito em fatura' />
            <p aria-hidden='true'>
              O montante de pontos recebidos e
              trocados por crédito em fatura
              equivalem percentualmente a um
              <strong> cashback de 6%.</strong>
            </p>
            <span className='hide-absolute'>O montante de pontos recebidos e trocados por crédito em fatura equivalem percentualmente a um cashback de 6%.</span>
          </div>
        </div>
      </div>
    </div>
  )
}

export default CashbackInfo



// WEBPACK FOOTER //
// ./src/features/LandingPage/LandingCashback/CashbackInfo/CashbackInfo.js